import { HTMLAttributes } from "react";

export default function BainTree(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
      {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5521 40.964H25.9861C33.2681 40.964 36.9101 38.564 36.9101 33.93C36.9101 29.38 33.0201 26.896 25.4061 26.896H16.5521V40.964ZM16.5521 7.034V20.11H24.8281C31.0341 20.11 34.2621 17.792 34.2621 13.572C34.2621 9.268 30.9521 7.034 24.7441 7.034H16.5521ZM3.39209 48V40.964H8.94009V7.034H3.39409V0H25.5721C35.7521 0 41.9581 4.716 41.9581 12.91C41.9581 18.29 38.8141 21.6 34.8421 23.172C40.5521 24.746 44.6061 28.8 44.6061 34.344C44.6061 43.116 37.8201 48 26.7301 48H3.39409"
        fill="black"
      />
    </svg>
  )
}
